import React, { useMemo, FC } from 'react'
import { ProgressBar, Button } from '@mch-group/uikit-components'
import style from './styles/index.module.scss'

/**
 * This Component can work in two modes, with progress bar and without progress bar. If "showProgressBar" is passed,
 * it is supposed to deal with the numbers passed, and use the 3 labels to generate a string. This has room for improvement.
 * @returns
 */
const ShowMore: FC<IShowMore> = ({
  numberOfViewedItems = 0,
  numberOfTotalItems = 0,
  onClick,
  isFetching,
  showProgressBar = true,
  showMoreLabel = 'Show More',
  disableButton = false,
  label1,
  label2,
  label3,
  hideButton,
  className,
  showCounterLabel = true
}) => {
  const percentageOfViewedItems = useMemo(
    () => (numberOfViewedItems / numberOfTotalItems) * 100,
    [numberOfViewedItems, numberOfTotalItems]
  )
  return (
    <div className={`${className} ${style['mch-show-more']}`} data-testid='mch-show-more'>
      {showProgressBar &&
        <ProgressBar
          percentage={percentageOfViewedItems}
          width='210px'
          className='mb-8 mx-auto mt-10'
          aria-label='progress-bar'
        />}
      <div className='d-flex flex-column align-items-center'>
        {showCounterLabel && showProgressBar &&
          <p
            className={`${style['product-shown-info']} mb-8`}
            data-testid='product-shown-info'
          >
            {/* As a reference: {`You have seen ${numberOfViewedItems} of ${numberOfTotalItems} special rooms`} */}
            {showProgressBar ? `${label1} ${numberOfViewedItems} ${label2} ${numberOfTotalItems} ${label3}` : label1}
          </p>
        }
        {!hideButton &&
          <Button
            variant='secondary'
            disabled={disableButton}
            onClick={onClick}
            className={style['show-more-btn']}
            isLoading={isFetching}
          >
            {showMoreLabel}
          </Button>
        }
      </div>
    </div>
  )
}

interface IShowMore {
  numberOfViewedItems?: number,
  numberOfTotalItems?: number,
  onClick?: () => {},
  isFetching?: boolean,
  label1?: string,
  label2?: string,
  label3?: string,
  disableButton?: boolean,
  showProgressBar?: boolean,
  showMoreLabel?: string
  showCounterLabel?: boolean,
  hideButton?: boolean,
  className?: string
}

export default ShowMore
